import { Stack } from "@mantine/core";
import { Text } from "../ui/Text";
import { Button } from "../ui/Button";
import { IconArrowRight } from "@tabler/icons-react";
import { useCallback } from "react";
import { Analytics } from "@/services/Analytics";

export function UserProfileNoResults(props: {
  title: string;
  description?: string;
  href?: string;
  buttonText?: string;
}) {
  const { title, href, buttonText } = props;

  const handleButtonClick = useCallback(
    (event: any) => {
      Analytics.click({
        context: "User profile",
        action: "User profile no results button",
        label: buttonText || "",
        event,
      });
    },
    [buttonText],
  );

  return (
    <Stack py={0} align="left" gap="xs">
      <Text c="text.5">{title}</Text>
      {href && buttonText && (
        <Button
          to={href}
          variant="light"
          color="primary"
          size="sm"
          radius="xl"
          rightSection={<IconArrowRight size={16} />}
          onClick={handleButtonClick}
        >
          {buttonText}
        </Button>
      )}
    </Stack>
  );
}
